<template>
  <div>
    <b-modal id="modalEditSystemGroups" ref="modalEditSystemGroups" :title="$t('System group')" hide-footer @shown="shown" size="lg">
      <div v-if="editItem">
        <b-form-group label-align="right" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.group_id">
          <b-form-input type="text" v-model="editItem.group_id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.group_name" aria-describedby="inputFeedbackName" :state="editItem.group_name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Comments')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.group_info"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Filter')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="editItem.group_id">
          <b-input-group>
            <b-form-input v-model="filter" :placeholder="$t('Type to Search')" @update="filterChanged"/>
            <b-img :src='searchDocumentImage'/>
          </b-input-group>
        </b-form-group>
        <b-table striped hover small responsive class="my-table" v-if="editItem.group_id"
        :items="func"
        :fields="funcFields"
        :filter="filter">
          <template v-slot:cell(is_allowed)="row">
            <b-form-checkbox v-model="row.item.is_allowed"/>
          </template>
        </b-table>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save') }}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditSystemGroups.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<style>
.my-table {
  max-height: 200px;
  overflow-y: auto;
}
</style>

<script>
export default {
  props: {
    editItem: null
  },
  data () {
    return {
      funcFields: [
        {key: 'number', label: this.$i18n.t('Function ID'), sortable: true},
        {key: 'fid_name', label: this.$i18n.t('Function name'), sortable: true},
        {key: 'fid_module', label: this.$i18n.t('Module'), sortable: true},
        {key: 'is_allowed', label: this.$i18n.t('Is allowed'), sortable: true}
      ],
      filter: '',
      searchDocumentImage: require('@/assets/img/search.png')
    }
  },
  methods: {
    save () {
      if (!this.editItem.group_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Name field is invalid'), 'Error')
        return
      }

      this.editItem.fids = []
      for (let el of this.func) {
        if (el.is_allowed) {
          let newEl = {
            fid: 0,
            allowed: 1
          }
          newEl.fid = el.fid_id
          this.editItem.fids.push(newEl)
        }
      }
      let response = this.editItem.group_id !== 0
        ? this.$store.dispatch('Users/UPDATE_SYSTEM_GROUPS', this.editItem)
        : this.$store.dispatch('Users/CREATE_SYSTEM_GROUPS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Users/GET_SYSTEM_GROUPS')
          this.$refs.modalEditSystemGroups.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    shown () {
      this.$store.dispatch('Users/GET_INFO_GROUP', this.editItem.group_id)
    },
    filterChanged (value) {
      this.filter = value
    }
  },
  computed: {
    func () {
      let copy = this.$store.getters['Users/INFO_GROUP'].fids
      for (let el of copy) {
        el.number = '0x' + JSON.parse(JSON.stringify(el.fid_id.toString(16)))
      }
      return copy
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/systemGroups/editModal.vue